var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLinkedinSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.578 6.92773H4V17.7683H7.578V6.92773Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.324 7.05486C17.286 7.04304 17.25 7.03023 17.21 7.01939C17.162 7.00855 17.114 6.99968 17.065 6.99179C16.875 6.95434 16.667 6.92773 16.423 6.92773C14.337 6.92773 13.014 8.42275 12.578 9.00025V6.92773H9V17.7683H12.578V11.8553C12.578 11.8553 15.282 8.14385 16.423 10.8698C16.423 13.303 16.423 17.7683 16.423 17.7683H20V10.4529C20 8.81498 18.861 7.45005 17.324 7.05486Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 5.44927C6.7165 5.44927 7.5 4.67713 7.5 3.72464C7.5 2.77215 6.7165 2 5.75 2C4.7835 2 4 2.77215 4 3.72464C4 4.67713 4.7835 5.44927 5.75 5.44927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLinkedinSmall);
export default __webpack_public_path__ + "static/media/white-linkedin-small.26b71034883c3e7ef25c8749a414af3a.svg";
export { ForwardRef as ReactComponent };